import Cell from "./cell";
import styled from "styled-components";

const DoubleCell = styled(Cell)`
  min-width: 120px;
`;

export default DoubleCell;
